import { defineDocument } from '../../schema';
export const blogIntroducingTheAirheadGamesDiscoveryHubDocument = defineDocument({
    id: 'blog:introducing-the-airhead-games-discovery-hub',
    kind: 'blog',
    slug: 'introducing-the-airhead-games-discovery-hub',
    route: '/blog/introducing-the-airhead-games-discovery-hub',
    seo: {
        title: 'Introducing the Airhead Games Discovery Hub',
        description: 'A centralized home for games, features, clips, music, and campaigns',
        imageAsset: 'blogDiscover',
    },
    hero: {
        eyebrow: [
            {
                type: 'text',
                text: 'Airhead Blog',
            },
        ],
        title: [
            {
                type: 'text',
                text: 'Introducing the Airhead Games Discovery Hub',
            },
        ],
        description: [
            {
                type: 'text',
                text: 'A centralized home for games, features, clips, music, and campaigns',
            },
        ],
        imageAsset: 'blogDiscover',
        imageAlt: 'Airhead Games Discovery Hub',
        showDescription: true,
        background: 'blurred-image',
    },
    meta: {
        author: 'Jay',
        publishedAt: new Date('2026-01-29T00:00:00.000Z'),
        tags: ['features'],
    },
    sections: [
        {
            id: 'article',
            blocks: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: 'The ',
                        },
                        {
                            type: 'link',
                            href: '/discover',
                            children: [
                                {
                                    type: 'text',
                                    text: 'Discovery Hub',
                                },
                            ],
                        },
                        {
                            type: 'text',
                            text: " is live! It's your home for learning about Airhead Games in one place. We built it to make the facts easy to find: what each game is like, what the platform can do, and plenty of gameplay content. We hope it helps you decide how our games fit your group.",
                        },
                    ],
                },
            ],
            sections: [
                {
                    id: 'article__what-you-can-discover',
                    title: [
                        {
                            type: 'text',
                            text: 'What You Can Discover',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: "Here's a little taste of what you might find:",
                                },
                            ],
                        },
                        {
                            type: 'list',
                            items: [
                                [
                                    {
                                        type: 'link',
                                        href: '/discover/games',
                                        children: [
                                            {
                                                type: 'text',
                                                text: 'Games',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'text',
                                        text: ': dive into key stats, play sequences, scoring rules, and game clips.',
                                    },
                                ],
                                [
                                    {
                                        type: 'link',
                                        href: '/discover/features',
                                        children: [
                                            {
                                                type: 'text',
                                                text: 'Features',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'text',
                                        text: ': understand user preferences, moderator tools, and more.',
                                    },
                                ],
                                [
                                    {
                                        type: 'link',
                                        href: '/discover/clips',
                                        children: [
                                            {
                                                type: 'text',
                                                text: 'Clips',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'text',
                                        text: ': browse all clips, or filter to just certain games or streamers.',
                                    },
                                ],
                                [
                                    {
                                        type: 'link',
                                        href: '/discover/music',
                                        children: [
                                            {
                                                type: 'text',
                                                text: 'Music',
                                            },
                                        ],
                                    },
                                    {
                                        type: 'text',
                                        text: ': listen to all the original songs in our music library, or filter to the artists you enjoy most.',
                                    },
                                ],
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Discover was built not just so you can learn about us, but also help you find the amazing streamers who play our games. Many pages have clips and links directing you to their Twitch channels. Check them out and drop a follow!',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__social-discovery',
                    title: [
                        {
                            type: 'text',
                            text: 'Social Discovery',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: "In addition to making Airhead Games content available on our website, we're also making it more discoverable all over the internet.",
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: "We're using our social channels to post Twitch clips of our community's gameplay. Our goal is to promote and spread awareness about the Twitch streamers who play our games. Within the first days of posting, we've already generated over 20,000 views of our streamer's content.",
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Follow us on ',
                                },
                                {
                                    type: 'link',
                                    href: 'https://www.youtube.com/@airhead-games',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'YouTube',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ', ',
                                },
                                {
                                    type: 'link',
                                    href: 'https://www.instagram.com/poppy_airhead_games/',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Instagram',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ', or ',
                                },
                                {
                                    type: 'link',
                                    href: 'https://www.tiktok.com/@poppy_airhead_games',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'TikTok',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' for hilarious gameplay clips.',
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            id: 'article-actions',
            widgets: [
                {
                    type: 'relatedDocuments',
                    limit: 4,
                },
            ],
        },
    ],
});
//# sourceMappingURL=introducing-the-airhead-games-discovery-hub.js.map